import React from "react";
import { Icon } from "@chakra-ui/react";
import {
  BiBuildingHouse,   // Internal expense
  BiUserCheck,       // Internal expense
  BiBriefcaseAlt2,   // Internal expense
  BiWorld,           // External expense
  BiCreditCard,      // External expense
  BiCog,             // Resource expense
  BiServer,          // Resource expense
  BiCubeAlt,          // Resource expense
  BiWallet,
  BiSend,
  BiMoneyWithdraw,
  BiAlarmExclamation,
  BiCreditCardFront,
  BiBadgeCheck,
  BiTag,
  BiAdjust,
  BiCheckShield
} from "react-icons/bi";
import { BsFillClipboardCheckFill } from "react-icons/bs";

export const moduleIcon = [
  {
    id:"I0",
    name: "Select Module Icon",
    value: "",
    icon: null,
  },

  // Internal Expenses
  {
    id:"I1",
    name: "Office Rent",
    value: "internal_rent",
    icon: <Icon as={BiBuildingHouse} width="20px" height="20px" color="inherit" />,
  },
  {
    id:"I2",
    name: "Employee Salary",
    value: "internal_salary",
    icon: <Icon as={BiUserCheck} width="20px" height="20px" color="inherit" />,
  },
  {
    id:"I3",
    name: "Team Activities",
    value: "internal_team",
    icon: <Icon as={BiBriefcaseAlt2} width="20px" height="20px" color="inherit" />,
  },

  // External Expenses
  {
    id:"I4",
    name: "International Services",
    value: "external_services",
    icon: <Icon as={BiWorld} width="20px" height="20px" color="inherit" />,
  },
  {
    id:"I5",
    name: "Vendor Payments",
    value: "external_vendor",
    icon: <Icon as={BiCreditCard} width="20px" height="20px" color="inherit" />,
  },

  // Resource Expenses
  {
    id:"I6",
    name: "Equipment",
    value: "resource_equipment",
    icon: <Icon as={BiCog} width="20px" height="20px" color="inherit" />,
  },
  {
    id:"I7",
    name: "Server Costs",
    value: "resource_server",
    icon: <Icon as={BiServer} width="20px" height="20px" color="inherit" />,
  },
  {
    id:"I8",
    name: "Consumables",
    value: "resource_consumables",
    icon: <Icon as={BiCubeAlt} width="20px" height="20px" color="inherit" />,
  },
];


export const saleModuleIcon = [
  {
    id:"I0",
    name: "Select Module Icon",
    value: "",
    icon: null,
  },
  {
    id:"I1",
    name: "Payment Received",
    value: "payment_received",
    icon: <Icon as={BiWallet} width="20px" height="20px" color="inherit" />
  },
  {
    id:"I2",
    name: "Invoice Details",
    value: "invoice_details",
    icon: <Icon as={BsFillClipboardCheckFill} width="20px" height="20px" color="inherit" />
  },
  {
    id:"I3",
    name: "Invoice Sent",
    value: "invoice_sent",
    icon: <Icon as={BiSend} width="20px" height="20px" color="inherit" />
  },
  {
    id:"I4",
    name: "Refund Issued",
    value: "refund_issued",
    icon: <Icon as={BiMoneyWithdraw} width="20px" height="20px" color="inherit" />
  },
  {
    id:"I5",
    name: "Overdue",
    value: "overdue",
    icon: <Icon as={BiAlarmExclamation} width="20px" height="20px" color="inherit" />
  },
  {
    id:"I6",
    name: "Credit Note",
    value: "credit_note",
    icon: <Icon as={BiCreditCardFront} width="20px" height="20px" color="inherit" />
  },
  {
    id:"I7",
    name: "Tax Applied",
    value: "tax_applied",
    icon: <Icon as={BiBadgeCheck} width="20px" height="20px" color="inherit" />
  },
  {
    id:"I8",
    name: "Discount Applied",
    value: "discount_applied",
    icon: <Icon as={BiTag} width="20px" height="20px" color="inherit" />
  },
  {
    id:"I9",
    name: "Partial Payment",
    value: "partial_payment",
    icon: <Icon as={BiAdjust} width="20px" height="20px" color="inherit" />
  },
  {
    id:"I10",
    name: "Invoice Approved",
    value: "invoice_approved",
    icon: <Icon as={BiCheckShield} width="20px" height="20px" color="inherit" />
  }
]


export const getSeletedIcon = (iconImg) => {
  const module =  moduleIcon.find((icon) => icon.id === iconImg);
  if(module){
    return module?.icon;
  }
};

export const getSeletedSalesModuleIcon = (iconImg) => {
  const module =  saleModuleIcon.find((icon) => icon.id === iconImg);
  if(module){
    return module?.icon;
  }

};